import { createRouter, createWebHistory } from 'vue-router'
import { routes } from './routes'
import { authGuard } from './guards/auth.guard'
import { experienceGuard } from './guards/experience.guard'
import { datapointGuard } from './guards/datapoint.guard'
import { setPageTitle } from './middleware/page-title'

export const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
  scrollBehavior(_to, _from, savedPosition) {
    return savedPosition || { top: 0 }
  },
})

router.beforeEach(authGuard)
// After authGuard: it aborts unauthenticated navigations (OIDC redirect), so the
// new-UI beta gate only ever sees signed-in users.
router.beforeEach(experienceGuard)
// After the beta gate: datapoint-restricted routes (e.g. People Search) redirect to the dashboard.
router.beforeEach(datapointGuard)
router.afterEach(setPageTitle)
